import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Sparkles, PenLine } from "lucide-react";
import { T } from "../context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ArticleStrip = ({ tag, title = "From the Editorial Desk", limit = 3 }) => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    axios.get(`${API}/articles`, { params: tag ? { tag } : {} })
      .then((r) => setArticles(r.data.slice(0, limit))).catch(() => {});
  }, [tag, limit]);

  if (!articles.length) return null;

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-6" data-testid="article-strip">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 text-xl font-bold text-slate-900"><PenLine className="h-5 w-5 text-[#0055FF]" /> <T>{title}</T></h2>
        <Link to="/articles" data-testid="all-articles-link" className="text-sm font-bold text-[#0055FF] hover:underline"><T>All articles</T> →</Link>
      </div>
      <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-3">
        {articles.map((a) => (
          <Link key={a.article_id} to={`/articles/${a.article_id}`} data-testid={`article-strip-${a.article_id}`} className="rounded-xl border border-slate-200 p-4 transition-all hover:-translate-y-0.5 hover:border-[#0055FF]">
            <div className="flex flex-wrap items-center gap-1.5">
              <span className="inline-flex items-center gap-1 rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-bold text-blue-700"><Sparkles className="h-3 w-3" />AI</span>
              {a.tags.slice(0, 2).map((t) => <span key={t} className="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-600">{t}</span>)}
            </div>
            <p className="mt-2 text-sm font-bold leading-snug text-slate-900"><T>{a.title}</T></p>
          </Link>
        ))}
      </div>
    </section>
  );
};
